module.exports = function anonymous(locals, filters, escape, rethrow
) {
escape = escape || function(html){
  return String(html)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/'/g, '&#39;')
    .replace(/"/g, '&quot;');
};
var __stack = { lineno: 1, input: "<h1><%- copy.headline1 %></h1> <p><%- copy.paragraph1 %></p> <% if(copy.button.display == 'true') { %> <button class=\"btn-close\"><%= copy.button.text %></button> <% } %>", filename: undefined };
function rethrow(err, str, filename, lineno){
  var lines = str.split('\n')
    , start = Math.max(lineno - 3, 0)
    , end = Math.min(lines.length, lineno + 3);

  // Error context
  var context = lines.slice(start, end).map(function(line, i){
    var curr = i + start + 1;
    return (curr == lineno ? ' >> ' : '    ')
      + curr
      + '| '
      + line;
  }).join('\n');

  // Alter exception message
  err.path = filename;
  err.message = (filename || 'ejs') + ':'
    + lineno + '\n'
    + context + '\n\n'
    + err.message;

  throw err;
}
try {
var buf = [];
with (locals || {}) { (function(){ 
 buf.push('<h1>', (__stack.lineno=1,  copy.headline1 ), '</h1> <p>', (__stack.lineno=1,  copy.paragraph1 ), '</p> ');__stack.lineno=1; if(copy.button.display == 'true') { ; buf.push(' <button class="btn-close">', escape((__stack.lineno=1,  copy.button.text )), '</button> ');__stack.lineno=1; } ; buf.push(''); })();
} 
return buf.join('');
} catch (err) {
  rethrow(err, __stack.input, __stack.filename, __stack.lineno);
}
}


//////////////////
// WEBPACK FOOTER
// ./app/scripts/templates/error.ejs
// module id = 208
// module chunks = 0